/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：309
 */

var r = require(/* 424 */"../1720/424")
module.exports = function (e) {
  return Object(r(e))
}
